<script src="../node_modules/jquery/dist/jquery.js"></script>
<script src="../node_modules/bootstrap/dist/js/bootstrap.js"></script>

<style>

</style>
<!--<nav class="navbar navbar-b navbar-expand-md fixed-top navbar-reduce" (scroll)="scrollHandler($event)">-->
<!--&lt;!&ndash;  <img src="assets/circle-cropped.png" class="align-content-center" style="width: 4%; margin: 1%">&ndash;&gt;-->
<!--&lt;!&ndash;  <span class="navbar-brand" >Rice Creek</span>&ndash;&gt;-->
<!--  <div class="collapse navbar-collapse" id="collapsibleNavbar" style="margin-left: 40%">-->
<!--    <ul class="navbar-nav" style="width: 44%;">-->
<!--      <li class="nav-item nav-margin">-->
<!--        <a class="nav-link nav-text" routerLinkActive="active" routerLink="/home">Home</a>-->
<!--      </li>-->
<!--      <li class="nav-item nav-margin">-->
<!--        <a class="nav-link nav-text" routerLink="/about">About Us</a>-->
<!--      </li>-->
<!--    </ul>-->
<!--  </div>-->
<!--</nav>-->
<!--<router-outlet></router-outlet>-->
<home-component></home-component>
